module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();

var border = [1, 2, 3, 4, 5, 6, 7];
var radius = [0, 1, 2, 3, 4, 5, 6, 7];

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Tables</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Header Text</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"tableHeaderText\" name=\"tableHeaderTextColor\" type=\"color\" value=\"")
    ; __append(escapeFn( tableHeaderTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableHeaderTextColor\" name=\"tableHeaderTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableHeaderTextColor ))
    ; __append("\" />\r\n\r\n            <select name=\"tableHeaderFont\" class=\"style-font\"  id=\"tableHeaderFont\">\r\n              \r\n            </select>\r\n\r\n            <select name=\"tableHeaderFontSize\" id=\"tableHeaderFontSize\" class=\"style-font-size\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"tableHeaderTextBold\" class=\"weightSelectorTable\" name=\"tableHeaderTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( tableHeaderTextWeightSelection ))
    ; __append("\" />\r\n            <img id=\"tableHeaderTextItalic\" class=\"styleSelectorTable\" name=\"tableHeaderTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( tableHeaderTextStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\" title=\"Header Background\">Header Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"tableHeaderBg\" name=\"tableHeaderBgColor\" type=\"color\" value=\"")
    ; __append(escapeFn( tableHeaderBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableHeaderBgColor\" name=\"tableHeaderBgColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableHeaderBgColor ))
    ; __append("\" />\r\n\r\n            <input id=\"tableHeaderBgGradient\" name=\"tableHeaderBgGradientColor\" type=\"color\" value=\"")
    ; __append(escapeFn( tableHeaderBgGradientColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableHeaderBgGradientColor\" name=\"tableHeaderBgGradientColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableHeaderBgGradientColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Rows</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"tableRowColor-1\" name=\"tableRowColor1\" type=\"color\" value=\"")
    ; __append(escapeFn( tableRowColor1 ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableRowColor1\" name=\"tableRowColor1\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableRowColor1 ))
    ; __append("\" />\r\n\r\n            <input id=\"tableRowColor-2\" name=\"tableRowColor2\" type=\"color\" value=\"")
    ; __append(escapeFn( tableRowColor2 ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableRowColor2\" name=\"tableRowColor2\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableRowColor2 ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Border</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"tableBorder\" name=\"tableBorderColor\" type=\"color\" value=\"")
    ; __append(escapeFn( tableBorderColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableBorderColor\" name=\"tableBorderColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableBorderColor ))
    ; __append("\" />\r\n\r\n            <select name=\"tableBorderStyle\" class=\"style-font\" id=\"tableBorderStyle\">\r\n                <option value=\"none\">None</option>\r\n                <option value=\"solid\">Solid</option>\r\n            </select>\r\n\r\n            <select name=\"tableBorderSize\" id=\"tableBorderSize\" class=\"style-border-size\">\r\n                ")
    ;  for (var i = 0; i < border.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(border[i]))
    ; __append("\">")
    ; __append(escapeFn(border[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <select name=\"tableBorderRadius\" id=\"tableBorderRadius\" class=\"style-border-radius\">\r\n                ")
    ;  for (var i = 0; i < radius.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(radius[i]))
    ; __append("\">")
    ; __append(escapeFn(radius[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"tableBg\" name=\"tableBgColor\" type=\"color\" value=\"")
    ; __append(escapeFn( tableBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableBgColor\" name=\"tableBgColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( tableBgColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}